import { type HttpClient } from '@/application/interfaces/http-client';

import { getStocks } from './get-stocks';

const StoreService = (httpClient: HttpClient.Instance) => ({
  getStocks: getStocks(httpClient),
});

export default StoreService;
